module.exports = __webpack_public_path__ + "img/row-srp-preview-lincoln.7289fd89.png";